export const SENTRY_SESSION_STORAGE_KEYS = {
  traceSampleRate: 'sentryTraceSampleRate',
  errorSampleRate: 'sentryErrorSampleRate',
  debug: 'sentryDebug',
} as const;
